var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticStyle:{"margin":"10px"}},_vm._l((_vm.mainList),function(item,index){return _c('li',{key:index,staticStyle:{"padding-right":"10px","font-size":"larger"}},[_vm._v(" "+_vm._s(item)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }